/* eslint-disable @typescript-eslint/indent */
import { Order, ApiResponse } from '../types';
import apiClient from './api-client';

const BASE_URL = '/orders';

export interface ProcessingOrdersStats {
  orders: Order[];
  total_processing_count: number;
  month_percentage: number;
}

export interface CompletedOrdersValueStats {
  total_value_last_month: number;
  previous_month_percentage: number;
}

export const getProcessingOrders = async (): Promise<ApiResponse<ProcessingOrdersStats>> => {
  const data = await apiClient.get<ProcessingOrdersStats>(`${BASE_URL}/processing`);
  return { data, success: true };
};

export const getCompletedOrdersValue = async (): Promise<
  ApiResponse<CompletedOrdersValueStats>
> => {
  const data = await apiClient.get<CompletedOrdersValueStats>(`${BASE_URL}/completed-value`);
  return { data, success: true };
};

export const getOrders = async (): Promise<ApiResponse<Order[]>> => {
  const data = await apiClient.get<Order[]>(BASE_URL + '/');
  return { data, success: true };
};

export const searchOrders = async (searchTerm: string): Promise<ApiResponse<Order[]>> => {
  const data = await apiClient.get<Order[]>(
    `${BASE_URL}/?search=${encodeURIComponent(searchTerm)}`
  );
  return { data, success: true };
};

export const getOrderById = async (orderId: string): Promise<ApiResponse<Order>> => {
  const data = await apiClient.get<Order>(`${BASE_URL}/${orderId}`);
  return { data, success: true };
};

export const updateOrderStatus = async (
  orderId: string,
  status: Order['status']
): Promise<ApiResponse<Order>> => {
  const data = await apiClient.put<Order, { status: Order['status'] }>(
    `${BASE_URL}/${orderId}/status`,
    {
      status,
    }
  );
  return { data, success: true };
};

export const cancelOrder = async (orderId: string, reason: string): Promise<ApiResponse<Order>> => {
  const data = await apiClient.put<Order, { reason: string }>(`${BASE_URL}/${orderId}/cancel`, {
    reason,
  });
  return { data, success: true };
};

export const getOrderItems = async (orderId: string): Promise<ApiResponse<any[]>> => {
  const data = await apiClient.get<any[]>(`${BASE_URL}/${orderId}/items`);
  return { data, success: true };
};

export const getOrderShippingDetails = async (orderId: string): Promise<ApiResponse<any>> => {
  const data = await apiClient.get<any>(`${BASE_URL}/${orderId}/shipping`);
  return { data, success: true };
};

export const updateShippingAddress = async (
  orderId: string,
  shippingAddressId: string
): Promise<ApiResponse<Order>> => {
  const data = await apiClient.put<Order, { shipping_address_id: string }>(
    `${BASE_URL}/${orderId}/shipping-address`,
    { shipping_address_id: shippingAddressId }
  );
  return { data, success: true };
};

export const updatePaymentMethod = async (
  orderId: string,
  paymentMethod: string,
  paymentTerm: string
): Promise<ApiResponse<Order>> => {
  const data = await apiClient.put<Order, { payment_method: string; payment_term: string }>(
    `${BASE_URL}/${orderId}/payment`,
    { payment_method: paymentMethod, payment_term: paymentTerm }
  );
  return { data, success: true };
};

export const getOrdersByCustomerId = async (customerId: string): Promise<ApiResponse<Order[]>> => {
  const data = await apiClient.get<Order[]>(`${BASE_URL}/customers/${customerId}`);
  return { data, success: true };
};
